import { Box, Typography } from '@mui/material';
import { FC } from 'react';

interface InfoRowProps {
  label: string;
  value: string;
}

const InfoRow: FC<InfoRowProps> = ({ label, value }) => {
  return (
    <Box
      display="flex"
      sx={{
        flexDirection: 'row',
        textAlign: 'left',
        justifyContent: 'flex-start',
        alignItems: 'baseline',
        whiteSpace: 'nowrap', // Evita quebra de linha
      }}
    >
      <Typography variant="body1" fontWeight="bold">
        {label}
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{
          fontSize: {
            xs: '0.75rem',
            sm: '0.875rem',
            marginLeft: 2,
          },
          color:
            value === 'Manter bloqueado' || value === 'Encerrar bloqueio'
              ? 'red'
              : 'inherit',
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};

export default InfoRow;
